var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"campaign"},[_c('base-form',{staticClass:"campaign__form"},[_c('base-card',{staticClass:"campaign__details",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('global.details'))+" ")]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"campaign__body display--grid page--single__grid"},[_c('base-field',{staticClass:"campaign__body__name",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.name') },
                            input: {
                                component: 'InputBasic',
                                id: 'name',
                                name: 'name',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.model.name,
                                browserAutocomplete: 'name',
                                isRequired: _vm.$route.meta.isAdd,
                                isMissing: _vm.errors.missing.name,
                                errorOnSubmit: {
                                    show: _vm.errors.api.name ? true : false,
                                    messages: _vm.errors.api.name
                                }
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: _vm.permissions.allowFilling
                        }}}),_c('base-field',{staticClass:"campaign__body__bdate",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.beginDate') },
                            input: {
                                component: 'InputCalendar',
                                name: 'beginDate',
                                id: 'beginDate',
                                targetClass: 'field__input--default typography--default color--default',
                                value: _vm.model.beginDate,
                                browserAutocomplete: 'off',
                                isRequired: _vm.$route.meta.isAdd,
                                isMissing: _vm.errors.missing.beginDate,
                                errorOnSubmit: {
                                    show: _vm.errors.api.beginDate ? true : false,
                                    messages: _vm.errors.api.beginDate
                                },
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: _vm.permissions.allowFilling
                        }}}),_c('base-field',{staticClass:"campaign__body__edate",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.endDate') },
                            input: {
                                component: 'InputCalendar',
                                name: 'endDate',
                                id: 'endDate',
                                targetClass: 'field__input--default typography--default color--default',
                                value: _vm.model.endDate,
                                dynamicData: {
                                    configs: {
                                        minDate: _vm.minDate,
                                    }
                                },
                                browserAutocomplete: 'off',
                                isRequired: _vm.$route.meta.isAdd,
                                isMissing: _vm.errors.missing.endDate,
                                fileValidation: 'isAfterCertainDate',
                                errors: [{
                                    type: 'isAfter', warning: _vm.$t('error.isAfter', { date: _vm.$t('global.beginDate') })
                                }],
                                errorOnSubmit: {
                                    show: _vm.errors.api.endDate ? true : false,
                                    messages: _vm.errors.api.endDate
                                },
                                validationParameter: _vm.payload.beginDate
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: _vm.permissions.allowFilling
                        }}}),_c('base-field',{staticClass:"campaign__body__type",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.type') },
                            input: {
                                component: 'InputAutocomplete',
                                id: 'typeId',
                                name: 'typeId',
                                type: 'text',
                                value: ("" + (_vm.types.api.id)),
                                targetClass: 'field__input--default typography--default color--default',
                                isRequired: _vm.$route.meta.isAdd,
                                isMissing: _vm.errors.missing.typeId,
                                browserAutocomplete: 'off',
                                dynamicData: {
                                    data: _vm.types.drop,
                                    apiValue: { value: ("" + (_vm.types.api.id)), label: _vm.types.api.name }
                                },
                                errorOnSubmit: {
                                    show: _vm.errors.api.typeId ? true : false,
                                    messages: _vm.errors.api.typeId
                                }
                            },
                            reset: _vm.reset,
                            allowFilling: _vm.permissions.allowFilling && !_vm.isEdition
                        }}}),_c('base-field',{staticClass:"campaign__body__workflow",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.workflow') },
                            input: {
                                component: 'InputAutocomplete',
                                id: 'workflowId',
                                name: 'workflowId',
                                type: 'text',
                                value: ("" + (_vm.workflows.api.id)),
                                targetClass: 'field__input--default typography--default color--default',
                                isRequired: _vm.$route.meta.isAdd,
                                isMissing: _vm.errors.missing.workflowId,
                                browserAutocomplete: 'off',
                                dynamicData: {
                                    data: _vm.workflows.drop,
                                    apiValue: { value: ("" + (_vm.workflows.api.id)), label: _vm.workflows.api.name }
                                },
                                errorOnSubmit: {
                                    show: _vm.errors.api.workflowId ? true : false,
                                    messages: _vm.errors.api.workflowId
                                }
                            },
                            reset: _vm.reset,
                            allowFilling: _vm.permissions.allowFilling && !_vm.isEdition
                        }}}),_c('base-field',{staticClass:"campaign__body__ddi",attrs:{"settings":{
                            label: { class: 'uppercase', text: _vm.$t('global.ddi') },
                            input: {
                                component: 'InputAutocomplete',
                                id: 'ddi',
                                name: 'ddi',
                                type: 'text',
                                value: ("" + (_vm.ddis.api.id)),
                                targetClass: 'field__input--default typography--default color--default',
                                isRequired: _vm.$route.meta.isAdd,
                                isMissing: _vm.errors.missing.ddi,
                                browserAutocomplete: 'off',
                                dynamicData: {
                                    data: _vm.ddis.drop,
                                    apiValue: { value: ("" + (_vm.ddis.api.id)), label: _vm.ddis.api.name },
                                    ordering: _vm.campaignHelpersLoading
                                },
                                errorOnSubmit: {
                                    show: _vm.errors.api.ddi ? true : false,
                                    messages: _vm.errors.api.ddi
                                }
                            },
                            reset: _vm.reset,
                            allowFilling: _vm.permissions.allowFilling
                        }}}),(_vm.isEdition)?_c('base-field',{staticClass:"campaign__body__post-call-timer",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.automaticForward') },
                            input: {
                                component: 'InputBasic',
                                id: 'postCallTimer',
                                name: 'postCallTimer',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: ("" + (_vm.postCallTimer || '')),
                                browserAutocomplete: 'postCallTimer',
                                placeholder: _vm.$t('placeholders.no'),
                                isRequired: false,
                                isMissing: _vm.errors.missing.postCallTimer,
                                fileValidation: 'numberInt',
                                errors: [{
                                    type: 'integer', warning: _vm.$t('error.integer')
                                }],
                                errorOnSubmit: {
                                    show: _vm.errors.api.postCallTimer ? true : false,
                                    messages: _vm.errors.api.postCallTimer
                                }
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: _vm.permissions.allowFilling
                        }}}):_vm._e(),_c('base-field',{staticClass:"campaign__body__state",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.state') },
                            input: {
                                component: 'States',
                                name: 'state',
                                value: _vm.stateId,
                                dynamicData: {
                                    states: [ 1, 2, 3 ]
                                }
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: _vm.isEdition && _vm.permissions.allowFilling
                        }}})],1)]},proxy:true}])}),_c('div',{staticClass:"campaign__cols display--grid page--single__half"},[(_vm.isEdition)?_c('base-card',{staticClass:"campaign__totals-by-typification",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('reporting.totalsByTypification'))+" ")]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"campaign__body"},[_c('base-chart',{attrs:{"loading":_vm.charts.totalsByTypification.loading,"chart":_vm.charts.totalsByTypification.data}})],1)]},proxy:true}],null,false,2370563508)}):_vm._e(),(_vm.isEdition)?_c('base-card',{staticClass:"campaign__final-typifications-by-hour",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('reporting.finalTypificationsByHour'))+" ")]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"campaign__body"},[_c('base-chart',{attrs:{"loading":_vm.charts.finalTypificationsByHour.loading,"chart":_vm.charts.finalTypificationsByHour.data}})],1)]},proxy:true}],null,false,1794107098)}):_vm._e(),_c('base-card',{staticClass:"campaign__associations",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('global.associations'))+" ")]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"campaign__body"},[_c('base-field-with-url',{staticClass:"campaign__body__client",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.client') },
                                input: Object.assign({}, ( !_vm.isEdition && {
                                        component: 'InputAutocomplete',
                                        id: 'clientId',
                                        type: 'text',
                                        targetClass: 'field__input--default typography--default color--default',
                                        browserAutocomplete: 'off',
                                        isRequired: _vm.$route.meta.isAdd,
                                        isMissing: _vm.errors.missing.clientId,
                                        dynamicData: {
                                            data: [].concat( _vm.clients ),
                                            ordering: _vm.order.loading
                                        },
                                        errorOnSubmit: {
                                            show: _vm.errors.api.clientId ? true : false,
                                            messages: _vm.errors.api.clientId
                                        }
                                    }),
                                    {name: 'clientId',
                                    value: _vm.client.name}),
                                allowFilling: !_vm.isEdition && _vm.permissions.allowFilling
                            },"anchor":{
                                url: ("/clients/" + _vm.clientId),
                                disable: !_vm.clientId,
                                see: _vm.$store.getters.can( 'clients', 'see' ),
                                translationKey: 'viewProfile'
                            }}}),_c('base-field',{staticClass:"campaign__body__users",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.multiUsers') },
                                input: {
                                    component: 'InputMultiOptions',
                                    name: 'users',
                                    id: 'users',
                                    targetClass: 'field__input--default typography--default color--default',
                                    value: _vm.helpers.selectedUsers || [],
                                    browserAutocomplete: 'off',
                                    placeholder: _vm.$t('placeholders.select'),
                                    isMissing: _vm.errors.missing.users,
                                    dynamicData: {
                                        data: [].concat( ( _vm.users || _vm.associateUsers ) ),
                                        ordering: _vm.order.loading,
                                        isEditPage: !_vm.$route.meta.isAdd
                                    },
                                    errorOnSubmit: {
                                        show: _vm.errors.api.users ? true : false,
                                        messages: _vm.errors.api.users
                                    },
                                    noListener: true
                                },
                                isEdition: _vm.isEdition,
                                reset: _vm.reset,
                                allowFilling: _vm.permissions.allowFilling
                            }}})],1)]},proxy:true}])}),(_vm.isEdition)?_c('base-card',{staticClass:"campaign__script",attrs:{"add-margins":false},scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_c('div',{staticClass:"card__header__title capitalize"},[_vm._v(_vm._s(_vm.$t('global.scripts')))])]},proxy:true},{key:"card__body",fn:function(){return [_c('base-table',{attrs:{"headers":[
                            'name',
                            'state'
                        ],"list":_vm.model.scripts,"model":"script","settings":{
                            component: 'RowScripts',
                            warning: _vm.$t('global.scripts')
                        }},on:{"open-modal":_vm.openModal}})]},proxy:true}],null,false,2650312731)}):_vm._e(),(_vm.isEdition)?_c('base-card',{staticClass:"campaign__call-rules card--full-grid",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_c('div',{staticClass:"card__header__title capitalize"},[_vm._v(_vm._s(_vm.$t('global.callRules')))])]},proxy:true},{key:"card__body",fn:function(){return [_c('base-table',{attrs:{"headers":[
                            'name',
                            'limitNumberOfAttempts',
                            'intervalOfAttempts',
                            'price',
                            'notify',
                            'sharingRules'
                        ],"list":_vm.model.contactCallStates.filter( function (state) { return state.visible; } ),"model":"rules","settings":{
                            component: 'RowCallRules',
                            warning: _vm.$t('global.rules')
                        }},on:{"open-modal":_vm.openModalContactCallState}}),_c('base-field',{staticClass:"campaign__call-rules__emails",attrs:{"settings":{
                            label: {
                                class: 'capitalize',
                                text: _vm.$t('global.notificationEmails'),
                            },
                            input: {
                                component: 'InputList',
                                id: 'emails',
                                name: 'emails',
                                type: 'text',
                                value: _vm.model.emails || '',
                                browserAutocomplete: 'emails',
                                placeholder: _vm.$t( 'placeholders.pressSpaceToAddToTheList' ),
                                isRequired: _vm.$route.meta.isAdd,
                                isMissing: _vm.errors.missing.emails,
                                errorOnSubmit: {
                                    show: _vm.errors.api.emails ? true : false,
                                    messages: _vm.errors.api.emails,
                                },
                                list: _vm.helpers.selectedEmails || []
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: _vm.permissions.allowFilling && _vm.model.contactCallStates.some( function (state) { return state.notifiable === true; } )
                        }}})]},proxy:true}],null,false,1763704278)}):_vm._e(),(_vm.isEdition)?_c('base-card',{class:[
                    'campaign__schedule'
                ],attrs:{"add-margins":false},scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_c('div',{staticClass:"card__header__title capitalize"},[_vm._v(_vm._s(_vm.$t('global.schedule')))])]},proxy:true},{key:"card__body",fn:function(){return [_c('schedule-table',{attrs:{"headers":[
                            'Segunda feira',
                            'Terça feira',
                            'Quarta feira',
                            'Quinta feira',
                            'Sexta feira',
                            'Sábado',
                            'Domingo'
                        ],"list":_vm.model.schedules,"model":"schedule","addSchedule":_vm.addScheduleBool,"startsAtProp":_vm.startsAtValue,"endsAtProp":_vm.endsAtValue,"settings":{
                            component: 'RowSchedules',
                            warning: _vm.$t('global.scripts')
                        }},on:{"open-modal":_vm.openModal,"close-add-modal":function($event){return _vm.trigerAddSchedule()}}})]},proxy:true}],null,false,4189619886)}):_vm._e(),(_vm.isEdition)?_c('base-card',{staticClass:"campaign__templates",attrs:{"add-margins":false},scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_c('div',{staticClass:"card__header__title capitalize"},[_vm._v(_vm._s(_vm.$t('global.mailTemplates')))])]},proxy:true},{key:"card__body",fn:function(){return [_c('base-table',{attrs:{"headers":[
                            'name'
                        ],"list":_vm.model.mailingTemplates,"model":"mailTemplates","settings":{
                            component: 'RowMailTemplates',
                            warning: _vm.$t('global.mailTemplates')
                        }},on:{"open-modal":_vm.openModal}})]},proxy:true}],null,false,1709100239)}):_vm._e(),_c('base-card',{class:[
                    'campaign__observations',
                    ("campaign__observations--" + (_vm.isEdition ? 'full' : 'semi'))
                ],scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('global.observations'))+" ")]},proxy:true},{key:"card__body",fn:function(){return [_c('base-field',{class:[
                            'campaign__body__observations',
                            { 'background--grey--light': _vm.permissions.allowFilling }
                        ],attrs:{"settings":{
                            label: { class: 'field__label--hide', text: _vm.$t('global.observations') },
                            input: {
                                component: 'Textarea',
                                name: 'observations',
                                id: 'observations',
                                class: 'campaign__body__observations__field typography--default color--default',
                                value: _vm.model.observations || '',
                                placeholder: _vm.$t('placeholders.observations'),
                                disableClass: 'campaign__body__observations__field campaign__body__observations__field--disable display--block'
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: _vm.permissions.allowFilling
                        }}})]},proxy:true}])})],1)],1),(_vm.modal.show)?_c('modal',{key:_vm.modal.show,attrs:{"form":{
            class: 'modal__form--action display--flex',
            settings: Object.assign({}, {typeOfPreparation: 'script'},
                ( _vm.modal.active.button === 'delete' && { submissionType: 'processDelete' }))
        },"customSettings":{
            color: _vm.modal.active.color,
            button: {
                label: _vm.modal.active.button
            }
        },"executeCloseAction":!_vm.modal.loading},on:{"close":function($event){_vm.modal.show = false}},scopedSlots:_vm._u([{key:"modal__header",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t(("global." + (_vm.modal.active.translate))))+" ")]},proxy:true},{key:"modal__body",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t(("warning." + (_vm.modal.active.translate))))+" ")]},proxy:true},{key:"modal__info",fn:function(){return [_c('base-button',{staticClass:"modal__content__button--negative background--transparent border--grey",class:{ 'disable': _vm.modal.loading },domProps:{"innerHTML":_vm._s(_vm.$t('global.cancel'))},on:{"click":function($event){_vm.modal.show = false}}})]},proxy:true}],null,false,2262413234)}):_vm._e(),(_vm.modalContactCallState.show)?_c('modal',{key:_vm.modalContactCallState.show,attrs:{"form":{
            class: 'modal__form--action display--flex'
        },"customSettings":{
            color: _vm.modalContactCallState.active.color,
            button: {
                label: _vm.modalContactCallState.active.button
            }
        },"executeCloseAction":!_vm.modalContactCallState.loading},on:{"close":function($event){_vm.modalContactCallState.show = false}},scopedSlots:_vm._u([{key:"modal__header",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t(("global." + (_vm.modalContactCallState.active.translate))))+" ")]},proxy:true},{key:"modal__body",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t(("warning." + (_vm.modalContactCallState.active.translate))))+" ")]},proxy:true},{key:"modal__info",fn:function(){return [_c('base-button',{staticClass:"modal__content__button--negative background--transparent border--grey",class:{ 'disable': _vm.modalContactCallState.loading },domProps:{"innerHTML":_vm._s(_vm.$t('global.cancel'))},on:{"click":function($event){_vm.modalContactCallState.show = false}}})]},proxy:true}],null,false,1818223954)}):_vm._e(),_c('modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.importModal.show),expression:"importModal.show"}],key:_vm.importModal.show,attrs:{"form":{
            class: 'import__modal',
            settings: {
                typeOfPreparation: 'importContacts'
            }
        },"customSettings":{
            color: 'green',
            class: 'import__modal__content',
            button: {
                id: 'import-button',
                label: 'importContacts'
            },
            show: {
                infoSection: false,
                actions: _vm.importModal.type === 'entities' || ( _vm.importModal.type === 'file' && _vm.payload.hasOwnProperty('resources') )
            }
        },"executeCloseAction":!_vm.importModal.loading,"preventReset":true},on:{"close":function($event){return _vm.toggleImportContactsModal()}},scopedSlots:_vm._u([{key:"modal__header",fn:function(){return [_c('h2',{staticClass:"import__modal__header"},[_vm._v(_vm._s(_vm.$t('global.importContacts')))])]},proxy:true},{key:"modal__body",fn:function(){return [_c('form',{staticClass:"import__filters position--relative display--flex",attrs:{"id":"filterEntities","novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.filterEntities($event)}}},[(!_vm.importModal.type || _vm.importModal.type === 'file')?_c('div',{staticClass:"import__modal__options"},[_c('div',{staticClass:"import__modal__options__title"},[_vm._v(_vm._s(_vm.$t('global.howDoYouWantToImportContacts')))]),_c('div',{staticClass:"import__modal__options__content display--flex"},[_c('base-card-option',{class:{ 'card--import-contacts__option--selected': _vm.payload.hasOwnProperty('resources') },attrs:{"templates":{ have: true, list: [
                                { endpoint:'/campaigns/import-contact-requests?format=csv', format: 'csv' },
                                { endpoint:'/campaigns/import-contact-requests?format=xlsx', format: 'xlsx' } ]}},scopedSlots:_vm._u([{key:"card__icon",fn:function(){return [_c('base-field',{staticClass:"import__modal__options__resources",attrs:{"settings":{
                                        label: { class: 'field__label--hide' },
                                        input: {
                                            component: 'InputFile',
                                            id: 'resources',
                                            name: 'resources',
                                            type: 'file',
                                            value: '',
                                            targetClass: 'field__input--default typography--default color--default',
                                            browserAutocomplete: 'off',
                                            formatsAllowed: [ '.csv', '.xlsx', '.xls' ]
                                        },
                                        isEdition: false,
                                        allowFilling: true
                                    }}})]},proxy:true},{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t("global.importFile"))+" "),_c('span',{staticClass:"typography--light"},[_vm._v("(.csv, .xlsx)")])]},proxy:true}],null,false,2920207545)}),_c('base-card-option',{staticClass:"pointer",nativeOn:{"click":function($event){_vm.importModal.type = 'entities'}},scopedSlots:_vm._u([{key:"card__icon",fn:function(){return [_c('icon-select-entities')]},proxy:true},{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t("global.selectEntities"))+" "),_c('span',{staticClass:"typography--light"},[_vm._v("(CAE)")])]},proxy:true}],null,false,40327555)})],1)]):_vm._e(),(_vm.importModal.type === 'entities')?[_c('base-field',{staticClass:"import__filters__aec",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.EAC') },
                            input: {
                                component: 'InputMultiOptionsDrop',
                                name: 'economicActivityCodes',
                                id: 'economicActivityCodes',
                                type: 'text',
                                value: [],
                                targetClass: 'import__filters__districts field__input--default typography--default color--default',
                                browserAutocomplete: 'off',
                                placeholder: 'Ex: Arroz ou 01120',
                                dynamicData: {
                                    data: _vm.economicActivityCodes,
                                },
                                noListener: true
                            },
                            allowFilling: true
                        }},model:{value:(_vm.eacArray),callback:function ($$v) {_vm.eacArray=$$v},expression:"eacArray"}}),_c('base-field',{staticClass:"import__filters__districts",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.zone') },
                            input: {
                                component: 'InputAutocomplete',
                                name: 'districts',
                                id: 'districts',
                                type: 'text',
                                value: _vm.district,
                                targetClass: 'import__filters__districts field__input--default typography--default color--default',
                                browserAutocomplete: 'off',
                                placeholder: 'Ex: Porto',
                                dynamicData: {
                                    data: _vm.districts,
                                },
                                noListener: true
                            },
                            allowFilling: true
                        }},model:{value:(_vm.district),callback:function ($$v) {_vm.district=$$v},expression:"district"}}),_c('div',{staticClass:"display--flex import__filters__zipCode"},[_c('base-field',{staticClass:"import__filters__fromZipCode",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.zipCode') },
                                input: {
                                    component: 'InputBasic',
                                    name: 'fromZipCode',
                                    id: 'fromZipCode',
                                    type: 'text',
                                    mask: '####-###',
                                    value: _vm.fromZipCode,
                                    class: 'import__filters__fromZipCode field__input--default typography--default color--default',
                                    browserAutocomplete: 'off',
                                    placeholder: '0000-000',
                                    noListener: true
                                },
                                allowFilling: true
                            }},model:{value:(_vm.fromZipCode),callback:function ($$v) {_vm.fromZipCode=$$v},expression:"fromZipCode"}}),_c('span',{staticClass:"import__filters__zipCode--separator"},[_vm._v("-")]),_c('base-field',{staticClass:"import__filters__toZipCode",attrs:{"settings":{
                                label: { class: 'capitalize', text: '' },
                                input: {
                                    component: 'InputBasic',
                                    name: 'toZipCode',
                                    id: 'toZipCode',
                                    type: 'text',
                                    mask: '####-###',
                                    value: _vm.toZipCode,
                                    class: 'import__filters__fromZipCode field__input--default typography--default color--default',
                                    browserAutocomplete: 'off',
                                    placeholder: '0000-000',
                                    noListener: true
                                },
                                allowFilling: true
                            }},model:{value:(_vm.toZipCode),callback:function ($$v) {_vm.toZipCode=$$v},expression:"toZipCode"}})],1),_c('base-button',{staticClass:"import__filters__button display--flex",attrs:{"form":"filterEntities","type":"submit","hasHover":false,"customClass":true},scopedSlots:_vm._u([{key:"button__icon",fn:function(){return [_c('icon-lup')]},proxy:true}],null,false,356741210)})]:_vm._e()],2),(_vm.importModal.type === 'entities')?_c('base-table',{attrs:{"headers":[
                    'id',
                    'name',
                    'EAC',
                    'zone',
                    'zipCode',
                    'contact'
                ],"list":_vm.importModal.entities,"model":"entity","settings":{
                    component: 'RowEntities',
                    warning: _vm.$t('global.entities')
                }},on:{"open-modal":_vm.openModal}}):_vm._e()]},proxy:true}])}),(_vm.callRuleModal.show)?_c('modal',{key:'callRuleModal',attrs:{"form":{
            class: 'call-rule__modal',
            settings: {
                id: 'callRuleModal',
                typeOfPreparation: 'callRules'
            }
        },"customSettings":{
            color: 'green',
            class: 'call-rule__modal__content',
            button: {
                id: 'add-state-button',
                label: 'addState'
            },
            show: {
                infoSection: false
            }
        },"executeCloseAction":!_vm.callRuleModal.loading,"preventReset":true},on:{"close":function($event){return _vm.toggleCallRuleModal()}},scopedSlots:_vm._u([{key:"modal__header",fn:function(){return [_c('h2',{staticClass:"import__modal__header"},[_vm._v(_vm._s(_vm.$t('global.addCallState')))])]},proxy:true},{key:"modal__body",fn:function(){return [_c('div',{staticClass:"call-rule__modal__fields display--grid"},[_c('base-field',{staticClass:"call-rule__modal__state",staticStyle:{"z-index":"4"},attrs:{"settings":{
                        label: { class: 'call__modal__label capitalize', text: _vm.$t('global.state') },
                        input: {
                            component: 'InputAutocomplete',
                            id: 'contactCallState',
                            name: 'contactCallState',
                            type: 'text',
                            value: '',
                            targetClass: 'field__input--default typography--default color--default',
                            browserAutocomplete: 'off',
                            isRequired: true,
                            isMissing: _vm.errors.missing.contactCallState,
                            dynamicData: {
                                data: _vm.callRuleModal.states.drop,
                                ordering: _vm.campaignHelpersLoading
                            },
                            noListener: true,
                            needsToMatchOption: false
                        },
                        allowFilling: _vm.permissions.allowFilling
                    }}}),(_vm.canShowGroup)?_c('base-field',{staticClass:"call-rule__modal__group",attrs:{"settings":{
                        label: { class: 'call__modal__label capitalize', text: _vm.$t('global.group') },
                        input: {
                            component: 'InputAutocomplete',
                            id: 'group',
                            name: 'group',
                            type: 'text',
                            value: '',
                            targetClass: 'field__input--default typography--default color--default',
                            browserAutocomplete: 'off',
                            isRequired: true,
                            isMissing: _vm.errors.missing.group,
                            dynamicData: {
                                data: [
                                    {
                                        value: 2,
                                        label: _vm.$t('callGroups.successfull'),
                                    }, {
                                        value: 3,
                                        label: _vm.$t('callGroups.unsuccessful'),
                                    }, {
                                        value: 4,
                                        label: _vm.$t('callGroups.rescheduling'),
                                    } ]
                            },
                            noListener: true
                        },
                        allowFilling: _vm.permissions.allowFilling
                    }}}):_vm._e(),_c('base-field',{staticClass:"call-rule__modal__number-of-attempts",attrs:{"settings":{
                        label: { class: 'capitalize', text: _vm.$t('global.limitNumberOfAttempts') },
                        input: {
                            component: 'InputBasic',
                            id: 'numberOfAttempts',
                            name: 'numberOfAttempts',
                            type: 'text',
                            class: 'field__input--default typography--default color--default',
                            value: '',
                            browserAutocomplete: 'numberOfAttempts',
                            isRequired: false,
                            isMissing: _vm.errors.missing.numberOfAttempts,
                            fileValidation: 'numberInt',
                            errors: [{
                                type: 'integer', warning: _vm.$t('error.integer')
                            }],
                            errorOnSubmit: {
                                show: _vm.errors.api.numberOfAttempts ? true : false,
                                messages: _vm.errors.api.numberOfAttempts
                            }
                        },
                        isEdition: _vm.isEdition,
                        reset: _vm.reset,
                        allowFilling: _vm.permissions.allowFilling
                    }}}),_c('base-field',{staticClass:"call-rule__modal__interval-of-attempts",attrs:{"settings":{
                        label: { class: 'capitalize', text: _vm.$t('global.intervalOfAttempts') },
                        input: {
                            component: 'InputBasic',
                            id: 'intervalOfAttempts',
                            name: 'intervalOfAttempts',
                            type: 'text',
                            class: 'field__input--default typography--default color--default',
                            value: '',
                            browserAutocomplete: 'intervalOfAttempts',
                            placeholder: _vm.$t( 'placeholders.intervalOfAttempts' ),
                            isRequired: _vm.permissions.allowFilling
                                && _vm.payload.hasOwnProperty('numberOfAttempts')
                                && parseInt( _vm.payload.numberOfAttempts ) > 1,
                            isMissing: _vm.errors.missing.intervalOfAttempts,
                            fileValidation: 'intervalOfAttempts',
                            errors: [{
                                type: 'intervalOfAttempts', warning: _vm.$t('error.intervalOfAttempts')
                            }],
                            errorOnSubmit: {
                                show: _vm.errors.api.intervalOfAttempts ? true : false,
                                messages: _vm.errors.api.intervalOfAttempts
                            },
                            validationParameter: _vm.payload.numberOfAttempts
                        },
                        isEdition: _vm.isEdition,
                        reset: _vm.reset,
                        allowFilling: _vm.permissions.allowFilling
                            && _vm.payload.hasOwnProperty('numberOfAttempts')
                            && parseInt( _vm.payload.numberOfAttempts ) > 1
                    }}}),_c('base-field',{staticClass:"call-rule__modal__call-price",attrs:{"settings":{
                        label: { class: 'capitalize', text: _vm.$t('global.callPrice') },
                        input: {
                            component: 'InputBasic',
                            id: 'callPrice',
                            name: 'callPrice',
                            type: 'text',
                            class: 'field__input--default typography--default color--default',
                            value: '',
                            browserAutocomplete: 'callPrice',
                            placeholder: _vm.$t( 'placeholders.price' ),
                            isRequired: false,
                            isMissing: _vm.errors.missing.callPrice,
                            fileValidation: 'numberFloat',
                            errors: [{
                                type: 'decimal', warning: _vm.$t('error.price')
                            }],
                            errorOnSubmit: {
                                show: _vm.errors.api.callPrice ? true : false,
                                messages: _vm.errors.api.callPrice
                            }
                        },
                        isEdition: _vm.isEdition,
                        reset: _vm.reset,
                        allowFilling: _vm.permissions.allowFilling
                    }}}),_c('base-field',{staticClass:"call-rule__modal__notify",attrs:{"settings":{
                        label: { class: 'capitalize', text: _vm.$t('global.notify') },
                        input: {
                            component: 'InputToggle',
                            name: 'notify',
                            id: 'notify',
                            value: 0
                        },
                        isEdition: _vm.isEdition,
                        reset: _vm.reset,
                        allowFilling: true
                    }}}),_c('base-field',{staticClass:"call-rule__modal__sharing-rules",attrs:{"settings":{
                        label: { class: 'capitalize', text: _vm.$t('global.sharingRules') },
                        input: {
                            component: 'InputToggle',
                            name: 'sharingRules',
                            id: 'sharingRules',
                            value: 0
                        },
                        isEdition: _vm.isEdition,
                        reset: _vm.reset,
                        allowFilling: true
                    }}})],1)]},proxy:true}],null,false,471657619)}):_vm._e(),(!_vm.$route.meta.isAdd)?_c('widget-options',[(_vm.$store.getters.can( 'campaign', 'importContacts' ))?_c('widget-button',{staticClass:"capitalize",attrs:{"settings":{
                action: function () { return _vm.toggleImportContactsModal(); },
                label: 'importContacts'
            }}}):_vm._e(),(_vm.$store.getters.can( 'campaign', 'addMailTemplate' ))?_c('widget-anchor',{attrs:{"settings":{
                url: ("/campaigns/" + (_vm.model.id) + "/mail-templates/add"),
                label: 'addMailTemplate'
            }}}):_vm._e(),(_vm.$store.getters.can( 'campaign', 'edit' ))?_c('widget-button',{staticClass:"capitalize",attrs:{"settings":{
                action: function () { return _vm.toggleCallRuleModal(); },
                label: 'addCallState'
            }}}):_vm._e(),(_vm.$store.getters.can( 'script', 'add' ))?_c('widget-anchor',{attrs:{"settings":{
                url: ("/campaigns/" + (_vm.model.id) + "/scripts/add"),
                label: 'addScript'
            }}}):_vm._e(),(_vm.$store.getters.can( 'script', 'addSchedule' ))?_c('widget-button',{staticClass:"capitalize",attrs:{"settings":{
                action: function () { return _vm.trigerAddSchedule(); },
                label: 'addSchedule'
            }}}):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }